var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorderBottomLeftOpened = function SvgBorderBottomLeftOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 760,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v728c0 16.569 13.431 30 30 30h59",
    stroke: "#000"
  })));
};

export default SvgBorderBottomLeftOpened;